import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容栏目",
    links: [
      { to: "/category", label: "影视作品库" },
      { to: "/news", label: "资讯动态" },
      { to: "/special", label: "专题合集" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { to: "/about", label: "站点定位" },
      { to: "/about#contact", label: "联系方式" },
      { to: "/about#copyright", label: "版权声明" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-800 bg-background-900">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-accent-500/60 to-transparent"></div>
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500">
                <i className="ri-film-line text-lg text-background-950" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-base font-semibold tracking-[0.18em] text-foreground-950">
                  日本伦理
                </span>
                <span className="mt-1 font-label text-[10px] uppercase tracking-[0.28em] text-foreground-500">
                  Ethics Archive
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-600">
              一个专注于日本伦理题材影视作品的专业资料站。我们整理作品档案、撰写剧情解析、记录行业动态，为影视爱好者与文化研究者提供可检索、可深读的内容。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-foreground-500">
              站内所有作品、人物与事件均为虚构示例，不含真实播放或下载资源。
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title} className="md:col-span-2">
              <h4 className="flex items-center gap-2 font-label text-xs uppercase tracking-[0.22em] text-foreground-500">
                <span className="h-1 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
                {column.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-700 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="flex items-center gap-2 font-label text-xs uppercase tracking-[0.22em] text-foreground-500">
              <span className="h-1 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
              联系与订阅
            </h4>
            <a
              href="mailto:editor@nihon-rinri-demo.jp"
              className="mt-4 inline-flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-accent-400"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              editor@nihon-rinri-demo.jp
            </a>
            <p className="mt-3 text-xs leading-relaxed text-foreground-500">
              欢迎影评投稿、专题合作与内容纠错，我们会在一周内回复。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-twitter-x-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-8 w-8 items-center justify-center rounded-md border border-background-700 text-foreground-500"
                  aria-hidden="true"
                >
                  <i className={`${icon} text-sm`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 日本伦理 · Ethics Archive。保留所有权利。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>本站内容为演示用途</span>
            <span className="hidden h-3 w-px bg-background-700 sm:block"></span>
            <span>不提供在线播放与下载</span>
          </p>
        </div>
      </div>
    </footer>
  );
}